export const NewAppCookiesKey = {
  apiToken: 'nf-api-token',
  appLanguage: 'nf-app-language',
  lastSelectedWorkspaceId: 'nf-last-selected-workspace-id',
} as const;
